import { Component, OnInit, OnDestroy, Input, Output, EventEmitter, OnChanges, SimpleChanges } from '@angular/core';
import { BehaviorSubject, Subscription } from 'rxjs';
import { ClientSite } from 'src/app/models/clientsite';
import { SitePermissionInfo } from '../../my-hospital-users/my-hospital-user.model';

@Component({
    selector: 'app-site-permission-editor',
    templateUrl: './site-permission-editor.component.html',
    styleUrls: ['./site-permission-editor.component.scss']
})
export class SitePermissionEditorComponent implements OnInit, OnDestroy, OnChanges {
    allSitesWithPermission = new BehaviorSubject<SitePermissionInfo[]>([]);
    allSelected = false;

    @Input()
    permittedSiteIds: number[] = [];

    @Input()
    allSites: ClientSite[] = [];

    @Input()
    defaultSite: number | null;

    @Input()
    triggerSitesRefresh: EventEmitter<void>;

    @Output()
    sitePermissionChanged = new EventEmitter<SitePermissionInfo[]>();

    subscriptions = new Subscription();

    constructor() {}

    ngOnInit() {
        this.initSitesWithPermission(this.allSites, this.permittedSiteIds);

        if (this.triggerSitesRefresh) {
            this.subscriptions.add(
                this.triggerSitesRefresh.subscribe(_ => {
                    this.initSitesWithPermission(this.allSites, this.permittedSiteIds);
                })
            );
        }
    }

    ngOnChanges(changes: SimpleChanges) {
        const allSites = changes.allSites?.currentValue ?? this.allSites;
        const permittedSiteIds = changes.permittedSiteIds?.currentValue ?? this.permittedSiteIds;

        this.initSitesWithPermission(allSites, permittedSiteIds);
    }

    ngOnDestroy() {
        this.subscriptions.unsubscribe();
    }

    initSitesWithPermission(allSites: ClientSite[], permittedSiteIds: number[]) {
        const isOrgLevel = permittedSiteIds?.[0] === null && permittedSiteIds?.length === 1;

        const newSitesPermission = allSites
            ?.sort((siteA, siteB) => (siteA.siteName.localeCompare(siteB.siteName) < 0 ? -1 : 1))
            .map(site => new SitePermissionInfo(isOrgLevel || (permittedSiteIds?.includes(site.siteId) ?? false), site));

        if (newSitesPermission.filter(item => item.isPermitted).length === newSitesPermission.length) {
            this.allSelected = true;
        } else {
            this.allSelected = false;
        }
        this.allSitesWithPermission.next(newSitesPermission);
        this.sitePermissionChanged.emit(newSitesPermission);
    }

    selectAllSite(event) {
        const currentPermission = this.allSitesWithPermission.value;
        currentPermission.forEach(item => {
            item.isPermitted = event.checked;
        });
        this.allSelected = !this.allSelected;
        this.allSitesWithPermission.next(currentPermission);
        this.sitePermissionChanged.emit(currentPermission);
    }

    toggleSite(event, siteId, index) {
        const currentPermission = this.allSitesWithPermission.value;
        if (currentPermission[index].siteInfo.siteId === siteId) {
            currentPermission[index].isPermitted = event.checked;
        }
        if (currentPermission.filter(item => item.isPermitted).length === currentPermission.length) {
            this.allSelected = true;
        } else {
            this.allSelected = false;
        }
        this.allSitesWithPermission.next(currentPermission);
        this.sitePermissionChanged.emit(currentPermission);
    }
}
